// const axios = impor "axios").default;
import { Alert, ServerMessage } from "@/models/general";
import { LayoutModule } from "@/store/layout";
import axios, { AxiosResponse } from "axios";
import { get, has } from "lodash";
import { Auth } from "aws-amplify";
import router from "@/router";
import qs from "qs";

const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/api/v1`,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => {
    const p = qs.stringify(params);
    return p;
  },
});

api.interceptors.request.use(async (config) => {
  LayoutModule.showLoader();

  let jwt = "";
  try {
    jwt = await (await Auth.currentSession()).getAccessToken().getJwtToken();
  } catch (e) {
    console.log(e);
  }
  config.headers["Authorization"] = jwt;
  return config;
});

api.interceptors.response.use(
  (response) => {
    LayoutModule.hideLoader();
    const meta = has(response, "data.meta");
    const data = meta ? get(response, "data") : get(response, "data.data");

    return data ? data : get(response, "data");
  },
  (error) => {
    const errors = get(error, "response.data.errors", []);
    const status = get(error, "response.status", 500);

    if (errors.length > 0) {
      const alerts: Alert[] = [];

      if (status === 401) {
        alerts.push({
          text: "responses.unauthorized",
          type: "error",
        });

        router.push({ name: "home" });
      } else {
        errors.forEach((e: ServerMessage) => {
          console.log(e);

          const alert = {
            text: e.details,
            type: "error",
            meta: get(e, "meta", []),
          };

          alerts.push(alert);
        });
      }

      LayoutModule.setAlerts(alerts);
    } else {
      LayoutModule.setAlerts({
        text: "responses.server_error",
        type: "error",
      });
    }
    LayoutModule.hideLoader();
    return Promise.reject(error);
  }
);

export default api;
